var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,4.2c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.8,7.8,7.8c4.3,0,7.8-3.5,7.8-7.8C19.8,7.7,16.3,4.2,12,4.2z  M2.8,12c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2c0,5.1-4.1,9.2-9.2,9.2C6.9,21.2,2.8,17.1,2.8,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9,14.5c0.3,0.3,0.4,0.7,0.1,1.1c-0.9,1.2-2.4,1.9-4,1.9c-1.5,0-2.9-0.7-3.9-1.7c-0.3-0.3-0.2-0.8,0.1-1.1 c0.3-0.3,0.8-0.2,1.1,0.1C9.9,15.5,10.9,16,12,16c1.1,0,2.2-0.5,2.8-1.3C15.1,14.3,15.6,14.3,15.9,14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,9.6c0,0.8-0.6,1.4-1.4,1.4C8,11,7.4,10.4,7.4,9.6c0-0.8,0.6-1.4,1.4-1.4C9.5,8.3,10.1,8.9,10.1,9.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,9.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4C16,8.3,16.6,8.9,16.6,9.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.beda0ef6e9dca109d7c9245b6244b032.svg";
export { ForwardRef as ReactComponent };